import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import { CloseRounded } from '@mui/icons-material'
import axios from 'axios'

import { M_Table, M_Button, M_MessageBoard, M_SimpleTable, BufferService, LoadingContext } from 'src/M_Components'

const BlList = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const [isLabel, setIsLabel] = useState(true)
    const navigate = useNavigate()
    const BLService = new BufferService('viewBL')
    const [refresh, setRefresh] = useState(false)
    const [approvedId, setApprovedId] = useState('')

    const [openDeleteLine, setOpenDeleteLine] = useState(false)
    const [openDeleteContext, setOpenDeleteContext] = useState(false)
    const [openClauses, setOpenClauses] = useState(false)
    const [selectedBL, setSelectedBL] = useState(null)
    const [clausesData, setClausesData] = useState([])
    const [loadingClauses, setLoadingClauses] = useState(false)
    const [expandedRows, setExpandedRows] = useState({})
    const [clauseDetails, setClauseDetails] = useState({})
    const [loadingDetails, setLoadingDetails] = useState({})

    const ctx = useContext(LoadingContext)

    const ProcessStatusService = new BufferService('processStatus')
    const ClausesService = new BufferService('BLClause')
    const ClauseDetailsService = new BufferService('TransportClauseDetail')
    const RegenerateClausesService = new BufferService('blclause')

    useEffect(() => {
        sessionStorage.removeItem('filterName')
        sessionStorage.removeItem('filter')
        let tempApprove = ''
        ProcessStatusService.get().then(res => {
            res.Items.forEach(elem => {
                if (elem.StatusName === 'Approved') {
                    tempApprove = elem.Id

                    setApprovedId(tempApprove)
                }
            })
        })
    }, [])

    const getPermissions = (Type) => {
        const nameForRole = 'bls'
        const tempPerm = []
        const permLines = []
        const permButtons = []
        roles.forEach((role) => {
            if (role.match(nameForRole)) tempPerm.push(role.split(nameForRole)[1])
        })

        permLines.push({ label: t("LabelViewBL"), icon: 'pi pi-search', command: (data) => bufferRouteContext("go/viewBL", "View", data), needLine: true })
        if (tempPerm.includes('Create')) permButtons.push({
            label: t("LabelCreateBL"),
            element: <M_Button
                tooltip={t("LabelCreateBL")}
                entity={'booking'}
                label={t("LabelCreateBL")}
                icon={<img src='/icons/tableIcons/add.svg' alt='Add Row' className="iconTable" />}
                onGetline={saveline}
                key={'blCreate'}
                passIsTable={true}
                tableLabel={'Bookings'}
                // FILTER={`ProcessStatusId eq ${approvedId} and BLId eq null and ContainerInsertedDate ne null `}
                FILTER={`ProcessStatusId eq ${approvedId} and BLId eq null`}
            />,
            command: () => bufferRouteButtons("go/createBL", "Create"),
            needLine: true
        })
        if (tempPerm.includes('Edit')) {
            permLines.push({ label: t("LabelEditBL"), icon: 'pi pi-pencil', command: (data) => bufferRouteContext("go/createBL", "Edit", data), needLine: true })
            permButtons.push({ label: t("LabelEditBL"), element: 'default', source: '/icons/tableIcons/edit.svg', style: {}, command: (data) => bufferRouteButtons("go/createBL", "Edit", data), needLine: true })
        }
        if (tempPerm.includes('Delete')) {
            permLines.push({ label: t("LabelDeleteBL"), icon: 'pi pi-trash', command: (data) => setOpenDeleteContext(true), needLine: true })
            permButtons.push({ label: t("LabelDeleteBL"), element: 'default', source: '/icons/svgsDaNet/trash-2.svg', style: { filter: 'invert(11%) sepia(68%) saturate(6715%) hue-rotate(359deg) brightness(93%) contrast(115%)' }, command: (data) => setOpenDeleteLine(true), needLine: true })
        }
        
        if (Type === 'Context') return permLines
        if (Type === 'Buttons') return permButtons
    }

    const bufferRouteButtons = (url, operation) => {
        let tempData = sessionStorage.getItem('lines')
        if (tempData === 'undefined') {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempData = JSON.parse(tempData).pop()
        sessionStorage.removeItem('lines')
        sessionStorage.setItem('blContext', JSON.stringify(tempData)) 
        sessionStorage.setItem('BLStatus', tempData.BLStatus)
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit') {
            NewRoute(url, `Edit BL ${tempData.NrBooking}`)
        }
        if (operation === 'Create') {
            if (tempData.BookingStatus !== 'Approved') {
                toastMessages('error', '', t("LabelBookingNotApprov"))
                return
            }
            NewRoute(url, `Create BL ${tempData.NrBooking}`)
        }
        if (operation === 'View') {
            NewRoute(url, `View BL ${tempData.NrBooking}`)
        }
    }

    const bufferRouteContext = (url, operation) => {
        const tempData = sessionStorage.getItem('context')
        if (tempData === 'undefined') {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        sessionStorage.removeItem('context')
        sessionStorage.setItem('blContext', tempData)
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit') {
            NewRoute(url, `Edit BL ${JSON.parse(tempData).NrBooking}`)
        }
        if (operation === 'Create') {
            if (tempData.BookingStatus !== 'Approved') {
                toastMessages('error', '', t("LabelBookingNotApprov"))
                return
            }
            NewRoute(url, `Create BL ${JSON.parse(tempData).NrBooking}`)
        }
        if (operation === 'View') {
            NewRoute(url, `View BL ${JSON.parse(tempData).NrBooking}`)
        }
    }



    const NewRoute = (url, label) => {
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    const saveline = (obj) => {
        sessionStorage.setItem('blContext', JSON.stringify(obj))
        sessionStorage.setItem('operation', 'Create')

        if (obj.BookingStatus !== 'Approved') {
            toastMessages('error', '', t("LabelBookingNotApprov"))
            return
        }
        NewRoute("go/createBL", "Create BL")
    }

    const deleteBLButton = () => {
        ctx.setIsLoad(true)
        setOpenDeleteLine(false)
        let tempData = sessionStorage.getItem('lines')
        if (!tempData) {
            ctx.setIsLoad(false)
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempData = JSON.parse(tempData)
        sessionStorage.removeItem('lines')
        if (tempData.length === 0) ctx.setIsLoad(false)
        tempData.forEach(obj => {
            BLService.delete(obj.Id).then(ResData => {
                ctx.setIsLoad(false)
                if (ResData.name === 'AxiosError') {
                    //toastMessages('error', ResData.response.data.Message, '')
                    toastMessages('success', '', t("LabelEliminated"))
                    setOpenDeleteLine(false)
                    setRefresh(true)
                    return
                }
                setOpenDeleteLine(false)
                toastMessages('success', '', t("LabelEliminated"))
                setRefresh(true)
            })
        })
    }
    const deleteBLContext = () => {
        setOpenDeleteLine(false)
        let tempData = sessionStorage.getItem('context')

        if (!tempData) {
            toastMessages('error', '', t("SelectedLine"))
            return
        }

        ctx.setIsLoad(true)
        tempData = JSON.parse(tempData)
        sessionStorage.removeItem('context')

        BLService.delete(tempData.Id).then(ResData => {
            ctx.setIsLoad(false)
            if (ResData.name === 'AxiosError') {
                //toastMessages('error', ResData.response.data.Message, '')
                toastMessages('success', '', t("LabelEliminated"))
                setOpenDeleteContext(false)
                setRefresh(true)
                return
            }
            setOpenDeleteContext(false)
            toastMessages('success', '', t("LabelEliminated"))
            setRefresh(true)
        })
    }

    const onHide = (e) => {
        setIsLabel(e)
    }

    const openClausesPopup = () => {
        let tempData = sessionStorage.getItem('lines')
        if (tempData === 'undefined' || !tempData) {
            toastMessages('error', 'Seleção Obrigatória', 'Selecione um BL para visualizar as cláusulas')
            return
        }
        tempData = JSON.parse(tempData).pop()
        setSelectedBL(tempData)
        setOpenClauses(true)
        
        // Buscar clauses do BL usando o endpoint específico
        if (tempData?.Id) {
            setLoadingClauses(true)
            ClausesService.getId(`by-bl/${tempData.Id}`).then(res => {
                if (Array.isArray(res)) {
                    setClausesData(res)
                    if (res.length === 0) {
                        toastMessages('info', 'Informação', 'Este BL não possui cláusulas. Use o botão "Regenerar" para criar.')
                    }
                } else {
                    setClausesData([])
                }
                setLoadingClauses(false)
            }).catch(err => {
                console.error('Error fetching clauses:', err)
                toastMessages('error', 'Erro ao Carregar', 'Erro ao carregar as cláusulas do BL')
                setClausesData([])
                setLoadingClauses(false)
            })
        }
    }

    const closeClausesPopup = () => {
        setOpenClauses(false)
        setSelectedBL(null)
        setClausesData([])
        setExpandedRows({})
        setClauseDetails({})
        setLoadingDetails({})
    }

    const toggleRowExpansion = async (clauseId) => {
        const isCurrentlyExpanded = expandedRows[clauseId]
        
        setExpandedRows(prev => ({
            ...prev,
            [clauseId]: !isCurrentlyExpanded
        }))

        // Se está expandindo e ainda não carregou os detalhes
        if (!isCurrentlyExpanded && !clauseDetails[clauseId]) {
            setLoadingDetails(prev => ({ ...prev, [clauseId]: true }))
            
            try {
                // Buscar detalhes usando o ClauseName da BLClause
                const clause = clausesData.find(c => c.Id === clauseId)
                console.log('Selected clause:', clause)
                
                if (clause?.ClauseName) {
                    const url = `by-clause-code/${encodeURIComponent(clause.ClauseName)}`
                    console.log('Fetching clause details from:', url)
                    const details = await ClauseDetailsService.getId(url)
                    console.log('Received details:', details)
                    
                    setClauseDetails(prev => ({
                        ...prev,
                        [clauseId]: Array.isArray(details) ? details : []
                    }))
                } else {
                    console.log('No ClauseName found in clause')
                    setClauseDetails(prev => ({ ...prev, [clauseId]: [] }))
                }
            } catch (err) {
                console.error('Error fetching clause details:', err)
                console.error('Error response:', err?.response)
                toastMessages('error', '', 'Error loading clause details')
                setClauseDetails(prev => ({ ...prev, [clauseId]: [] }))
            } finally {
                setLoadingDetails(prev => ({ ...prev, [clauseId]: false }))
            }
        }
    }

    const handleRegenerateClauses = async () => {
        if (!selectedBL?.Id) {
            toastMessages('error', 'Erro', 'Selecione um BL para regenerar as cláusulas')
            return
        }

        // Confirmação com mensagem clara
        const confirmed = window.confirm(
            `Deseja regenerar as cláusulas do BL ${selectedBL.NrBooking || selectedBL.BLNumber || ''}?\n\n` +
            'Esta ação irá:\n' +
            '• Remover todas as cláusulas existentes\n' +
            '• Criar novas cláusulas baseadas nas regras configuradas\n\n' +
            'Confirmar?'
        )
        
        if (!confirmed) return

        ctx.setIsLoad(true)
        try {
            const url = RegenerateClausesService.url + RegenerateClausesService.entityName + `/regenerate/${selectedBL.Id}`
            const response = await axios.post(url)
            
            if (response?.data?.success) {
                const message = response.data.message || 
                    `${response.data.clausesCount || 0} cláusulas foram regeneradas com sucesso`
                toastMessages('success', 'Sucesso', message)
                
                // Recarregar as clauses após regenerar
                const refreshedClauses = await ClausesService.getId(`by-bl/${selectedBL.Id}`)
                if (Array.isArray(refreshedClauses)) {
                    setClausesData(refreshedClauses)
                    // Limpar detalhes expandidos
                    setExpandedRows({})
                    setClauseDetails({})
                }
            } else {
                toastMessages('error', 'Erro', response?.data?.message || 'Erro ao regenerar cláusulas')
            }
        } catch (err) {
            console.error('Error regenerating clauses:', err)
            console.error('Error response data:', err?.response?.data)
            const errorMessage = err?.response?.data?.message || err?.message || 'Erro ao regenerar cláusulas'
            toastMessages('error', 'Erro ao Regenerar', errorMessage)
        } finally {
            ctx.setIsLoad(false)
        }
    }

    const getLineBL = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const getContextBL = (e) => {
        if (e) {
            sessionStorage.setItem('context', JSON.stringify(e))
        } else {
        }
    }

    const removeContextItems = ['View', 'Create', 'Edit', 'Delete']

    return (
        <>
            <M_Table
                entityName={'bl'}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'BLs'}
                lineContext={getPermissions('Context')}
                extraButtons={getPermissions('Buttons')}
                removeContextItems={removeContextItems}
                onHideLabels={onHide}
                onPassLine={getLineBL}
                onPassContext={getContextBL}
                refresh={refresh}
                setRefresh={setRefresh}
                hiddenColumns={['Changes']}
            />
            <M_MessageBoard
                warning
                open={openDeleteContext}
                onClose={() => setOpenDeleteContext(false)}
                title={`${t("Delete")} BL ?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>BL</b>
                </span>}
                footer={
                    <span style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteContext(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteBLContext()}
                        />
                    </span>
                }
            />
            <M_MessageBoard
                warning
                open={openDeleteLine}
                onClose={() => setOpenDeleteLine(false)}
                title={`${t("Delete")} BL ?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>BL</b>
                </span>}
                footer={
                    <span style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteLine(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteBLButton()}
                        />
                    </span>
                }

            />
            <Dialog
                open={openClauses}
                onClose={closeClausesPopup}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    style: {
                        minHeight: '60vh',
                        maxHeight: '85vh'
                    }
                }}
            >
                <DialogTitle style={{ display: 'flex', alignItems: 'center' }}>
                    <b>BL Clauses - {selectedBL?.NrBooking}</b>
                </DialogTitle>
                <DialogContent>
                    <div style={{ height: '65vh', overflow: 'auto', width: '100%', padding: '20px' }}>
                        {loadingClauses ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <p>Loading clauses...</p>
                            </div>
                        ) : clausesData.length === 0 ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <p style={{ textAlign: 'center', color: 'var(--color-grey-dark)' }}>
                                    No clauses found for this BL.
                                </p>
                            </div>
                        ) : (
                            <M_SimpleTable
                                rows={clausesData}
                                columns={[
                                    {
                                        field: 'expand',
                                        header: '',
                                        body: (rowData) => (
                                            <i 
                                                className={expandedRows[rowData.Id] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'} 
                                                style={{ fontSize: '0.9rem', color: 'var(--color-blue)', cursor: 'pointer' }}
                                                onClick={() => toggleRowExpansion(rowData.Id)}
                                            />
                                        ),
                                        style: { width: '50px', textAlign: 'center' }
                                    },
                                    { field: 'ClauseKey', header: 'Clause Key' },
                                    { field: 'ClauseName', header: 'Clause Name' },
                                    { field: 'TradeLineCode', header: 'Trade Line' },
                                    { field: 'TransportModeCode', header: 'Transport Mode' },
                                    { field: 'TransportVesselCode', header: 'Vessel' },
                                    { field: 'TransportVoyageNumber', header: 'Voyage' },
                                    { 
                                        field: 'ClauseText', 
                                        header: 'Clause Text',
                                        body: (rowData) => (
                                            <div style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
                                                {rowData.ClauseText || '-'}
                                            </div>
                                        )
                                    }
                                ]}
                                rowExpansionTemplate={(rowData) => {
                                    if (!expandedRows[rowData.Id]) return null
                                    
                                    return (
                                        <div style={{ padding: '15px', backgroundColor: '#f8f9fa' }}>
                                            {loadingDetails[rowData.Id] ? (
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                                                    <p>Loading details...</p>
                                                </div>
                                            ) : clauseDetails[rowData.Id]?.length > 0 ? (
                                                <div>
                                                    <h4 style={{ marginBottom: '10px', color: 'var(--color-blue)' }}>Transport Clause Details</h4>
                                                    <M_SimpleTable
                                                        rows={clauseDetails[rowData.Id]}
                                                        columns={[
                                                            { field: 'DetailKey', header: 'Detail Key' },
                                                            { field: 'DetailDescription', header: 'Description' },
                                                            { field: 'TradeLineCode', header: 'Trade Line' },
                                                            { field: 'TradeCode', header: 'Trade Code' },
                                                            { field: 'TradeBound', header: 'Bound' },
                                                            { field: 'AccountId', header: 'Account' }
                                                        ]}
                                                        normal
                                                    />
                                                </div>
                                            ) : (
                                                <p style={{ textAlign: 'center', color: 'var(--color-grey-dark)', padding: '20px' }}>
                                                    No transport clause details found.
                                                </p>
                                            )}
                                        </div>
                                    )
                                }}
                                expandedRows={Object.keys(expandedRows).filter(key => expandedRows[key]).reduce((acc, key) => {
                                    const row = clausesData.find(c => c.Id === key)
                                    if (row) acc.push(row)
                                    return acc
                                }, [])}
                                normal
                            />
                        )}
                    </div>
                    <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                        <M_Button
                            none
                            icon={<CloseRounded style={{ color: 'var(--color-red)', scale: '1.5' }} />}
                            onClick={closeClausesPopup}
                        />
                    </div>
                    <div style={{ position: 'absolute', bottom: '20px', right: '20px' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Regenerate')}
                            icon={<i className="pi pi-refresh"></i>}
                            backgroundColor={'var(--color-blue)'}
                            labelColor={'var(--color-white)'}
                            onClick={handleRegenerateClauses}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}
export default BlList